import { DispatchHelpInputKind } from '@numeo/types'
import { Mic, MousePointerClick } from 'lucide-react'

// How the driver entered a message. Typed is the plain bubble; a voice-session relay and a suggestion
// tap each get a label and their own bubble tone, so the operator reads the three apart at a glance.
const LABELS = {
    voice: { text: 'Voice', Icon: Mic },
    suggestion: { text: 'Suggestion tap', Icon: MousePointerClick },
} as const

export const USER_BUBBLE_TONE: Record<DispatchHelpInputKind, string> = {
    typed: 'bg-accent text-accent-foreground',
    voice: 'bg-accent-soft text-accent-soft-foreground',
    suggestion: 'bg-surface text-foreground ring-1 ring-border',
}

export function UserInputKindLabel({ kind }: { kind: DispatchHelpInputKind }) {
    if (kind === 'typed') return null
    const { text, Icon } = LABELS[kind]
    return (
        <div className="flex items-center gap-1 text-[11px] font-semibold text-foreground-muted">
            <Icon className="h-3 w-3" /> {text}
        </div>
    )
}
